<div class="pdv" data-testid="pdv-root">
  <header class="pdv__topo">
    <div class="pdv__leitura">
      <label class="pdv__label" for="pdv-codigo">Código de barras</label>
      <input
        #leituraInput
        id="pdv-codigo"
        class="form-control pdv__input-leitura"
        type="text"
        autocomplete="off"
        autofocus
        placeholder="Leia o código e pressione Enter"
        data-testid="pdv-codigo-input"
        [formControl]="codigoControl"
        (keydown.enter)="onEnterOuTab($event)"
        (keydown.tab)="onEnterOuTab($event)"
        (blur)="onLeituraBlur()"
      />
    </div>
    <div class="pdv__cliente">
      <span class="pdv__cliente-nome" data-testid="pdv-cliente-nome">Cliente: {{ clienteNome || 'Consumidor final' }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        data-testid="pdv-identificar-cliente"
        [disabled]="emFechamento"
        (click)="identificarCliente()"
      >Identificar cliente (F8)</button>
    </div>
    <div class="pdv__sync-wrap">
      <span
        class="pdv__sync"
        [class.pdv__sync--sincronizando]="statusSync === 'sincronizando'"
        [class.pdv__sync--erro]="statusSync === 'erro'"
        role="status"
        data-testid="pdv-status-sync"
      >{{ statusSync === 'sincronizado' ? 'Sincronizado' : statusSync === 'sincronizando' ? 'Sincronizando...' : 'Sem conexão com o servidor' }}</span>
      @if (statusSync === 'erro') {
        <button type="button" class="btn btn-sm btn-outline-danger" data-testid="pdv-tentar-novamente" (click)="tentarNovamente()">Tentar novamente</button>
      }
    </div>
  </header>

  @if (rascunhoPendente) {
    <div class="pdv__retomar" role="alert" data-testid="pdv-retomar-banner">
      <span>Há uma venda em andamento ({{ rascunhoPendente.itens.length }} item(ns)). Deseja retomá-la?</span>
      <span class="pdv__retomar-acoes">
        <button type="button" class="btn btn-sm btn-primary" data-testid="pdv-retomar" (click)="retomar()">Retomar</button>
        <button type="button" class="btn btn-sm btn-outline-danger" data-testid="pdv-descartar" (click)="descartarRascunho()">Descartar</button>
      </span>
    </div>
  }

  @if (erroLeitura) {
    <div class="pdv__erro" role="alert" data-testid="pdv-erro-leitura">
      <i class="bi bi-exclamation-triangle-fill"></i> {{ erroLeitura }}
    </div>
  }

  <section class="pdv__grid-wrap">
    <table class="table pdv__grid" data-testid="pdv-grid">
      <thead>
        <tr>
          <th>Item</th>
          <th>Código</th>
          <th>Descrição</th>
          <th>Un.</th>
          <th class="text-end">Preço</th>
          <th class="text-end">Qtd</th>
          <th class="text-end">Total</th>
          <th class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        @for (linha of linhas; track linha.item.produtoId; let i = $index) {
          <tr
            class="pdv__linha"
            [class.pdv__linha--selecionada]="linha.item.produtoId === selecionadoId"
            [class.pdv__linha--ultimo]="linha.item.produtoId === ultimoLidoId"
            [attr.data-testid]="'pdv-item-' + linha.item.produtoId"
            (click)="selecionar(linha.item.produtoId)"
          >
            <td>{{ linhas.length - i }}</td>
            <td>{{ linha.item.codigoBarra }}</td>
            <td>{{ linha.item.descricao }}</td>
            <td>{{ linha.item.unMedida || 'UN' }}</td>
            <td class="text-end" [class.pdv__preco--alterado]="precosAlterados.has(linha.item.produtoId)" [attr.data-testid]="'pdv-preco-' + linha.item.produtoId">{{ linha.precoFormatado }}</td>
            <td class="text-end">
              @if (editandoId === linha.item.produtoId) {
                <input
                  #qtdInput
                  type="text"
                  inputmode="decimal"
                  class="form-control form-control-sm pdv__input-qtd"
                  [attr.data-testid]="'pdv-qtd-' + linha.item.produtoId"
                  [formControl]="quantidadeControl"
                  (keydown.enter)="confirmarQuantidade(); $event.preventDefault()"
                />
                @if (erroQuantidade) {
                  <small class="text-danger d-block" data-testid="pdv-erro-quantidade">{{ erroQuantidade }}</small>
                }
              } @else {
                <span
                  class="pdv__qtd"
                  [attr.data-testid]="'pdv-qtd-' + linha.item.produtoId"
                  (dblclick)="iniciarEdicaoQuantidade(linha.item.produtoId)"
                >{{ linha.quantidadeFormatada }}</span>
              }
            </td>
            <td class="text-end">{{ linha.totalFormatado }}</td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                title="Remover (F6)"
                aria-label="Remover item"
                [attr.data-testid]="'pdv-remover-' + linha.item.produtoId"
                (click)="remover(linha.item.produtoId); $event.stopPropagation()"
              >
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="8" class="pdv__vazio">Nenhum item. Leia um código de barras para começar.</td>
          </tr>
        }
      </tbody>
    </table>
  </section>

  <footer class="pdv__rodape">
    <dl class="pdv__resumo">
      <div>
        <dt>Subtotal</dt>
        <dd data-testid="pdv-subtotal">{{ subtotalFormatado }}</dd>
      </div>
      <div>
        <dt><label for="pdv-desconto">Desconto (%) - F4</label></dt>
        <dd>
          <input
            id="pdv-desconto"
            type="number"
            min="0"
            step="0.01"
            class="form-control form-control-sm pdv__input-desconto"
            [class.is-invalid]="descontoInvalido"
            data-testid="pdv-desconto-input"
            [formControl]="descontoControl"
            (blur)="onDescontoBlur()"
            (keydown.enter)="focarLeitura()"
          />
          @if (descontoInvalido) {
            <small class="text-danger d-block" data-testid="pdv-desconto-erro">Desconto deve estar entre 0% e {{ descontoMaximo }}%</small>
          }
        </dd>
      </div>
      <div>
        <dt>Desconto (R$)</dt>
        <dd data-testid="pdv-desconto-valor">{{ descontoValorFormatado }}</dd>
      </div>
    </dl>

    <div class="pdv__total">
      <span class="pdv__total-rotulo">TOTAL</span>
      <strong class="pdv__total-valor" data-testid="pdv-total">{{ totalFormatado }}</strong>
    </div>

    <div class="pdv__acoes">
      <button
        type="button"
        class="btn btn-outline-secondary btn-lg"
        data-testid="pdv-cancelar"
        (click)="pedirCancelamento()"
      >Cancelar (Esc)</button>
      <button
        type="button"
        class="btn btn-success btn-lg"
        data-testid="pdv-finalizar"
        [disabled]="!finalizarHabilitado || emFechamento"
        (click)="finalizar()"
      >Finalizar (F9)</button>
    </div>
  </footer>

  <p class="pdv__atalhos">F2 quantidade · F4 desconto · F6/Del remover · F8 cliente · F9 finalizar · Esc cancelar · setas selecionam</p>
</div>

<app-confirm-dialog
  [isOpen]="confirmarCancelamentoAberto"
  title="Cancelar venda"
  [message]="cancelMessage"
  confirmLabel="Descartar itens"
  cancelLabel="Voltar"
  [closeOnEscape]="false"
  (confirmed)="confirmarCancelamento()"
  (cancelled)="fecharCancelamento()"
></app-confirm-dialog>

<app-confirm-dialog
  [isOpen]="confirmarSaidaAberto"
  title="Sair do ponto de venda"
  [message]="saidaMensagem"
  confirmLabel="Sair e descartar"
  cancelLabel="Ficar"
  [closeOnEscape]="false"
  (confirmed)="confirmarSaida()"
  (cancelled)="cancelarSaida()"
></app-confirm-dialog>


@if (clienteModalAberto) {
  <app-cliente-modal
    [isOpen]="true"
    (closeModal)="fecharClienteModal()"
  ></app-cliente-modal>
}

@if (orcamentoFechamento) {
  <app-venda-modal-v2
    [isOpen]="vendaModalAberto"
    [orcamento]="orcamentoFechamento"
    [tipoAcao]="'NOVA_VENDA'"
    [clienteComRestricao]="restricaoCliente"
    (vendaEfetuada)="onVendaEfetuada($event)"
    (closeModal)="onVendaModalClose($event)"
  ></app-venda-modal-v2>
}

<app-cupom-venda-modal
  [isOpen]="cupomAberto"
  [cupom]="cupom"
  (closeModal)="fecharCupom()"
></app-cupom-venda-modal>
